import axios from "axios";
import { SuperAdminURL } from "../../../../config/UrlEndPoint";

export const URL = `${SuperAdminURL}notification_organization`;

//  * FIND NOTIFICATION TEMPLATE
export function findNotificationTemplate(queryParams) {
  return axios.post(`${URL}/find_template`, queryParams);
}
//  * FIND NOTIFICATION TEMPLATE BY ID
export function findNotificationTemplateById(id) {
  return axios.get(`${URL}/find_template/${id}`);
}
// * CREATE NOTIFICATION TEMPLATE
export function createNotificationTemplate(payload) {
  return axios.post(`${URL}/create_template`, payload);
}
// * UPDATE NOTIFICATION TEMPLATE
export function updateNotificationTemplate(payload) {
  return axios.put(`${URL}/update_template/${payload.uuid}`, payload);
}

// * UPDATE NOTIFICATION TEMPLATE
export function updateStatusNotificationTemplate(payload) {
  return axios.put(`${URL}/update_template_status/${payload.uuid}`, payload);
}

export function deleteNotificationTemplate(id) {
  return axios.delete(`${URL}/delete_template/${id}`);
}
